import React, { createContext, useContext, useState, useRef } from 'react';

const NotificationContext = createContext(null);

export const useNotify = () => {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error('useNotify must be used within NotificationProvider');
  return ctx;
};

let idCounter = 1;

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const timersRef = useRef({});

  const remove = (id) => {
    setNotifications((prev) => prev.filter((n) => n.id !== id));
    if (timersRef.current[id]) {
      clearTimeout(timersRef.current[id]);
      delete timersRef.current[id];
    }
  };

  const push = (type, message, duration = 5000) => {
    const id = idCounter++;
    setNotifications((prev) => [...prev, { id, type, message }]);
    if (duration > 0) {
      timersRef.current[id] = setTimeout(() => remove(id), duration);
    }
    return id;
  };

  const notify = {
    success: (msg, d) => push('success', msg, d),
    error: (msg, d) => push('error', msg, d ?? 7000),
    info: (msg, d) => push('info', msg, d),
    loading: (msg) => push('loading', msg, 0),
    dismiss: remove
  };

  return (
    <NotificationContext.Provider value={notify}>
      {children}
      <div className="notification-container">
        {notifications.map((n) => (
          <div key={n.id} className={`notification notification-${n.type}`}>
            <div className="notification-icon">
              {n.type === 'success' && '✓'}
              {n.type === 'error' && '✕'}
              {n.type === 'info' && 'ℹ'}
              {n.type === 'loading' && <span className="notification-spinner" />}
            </div>
            <div className="notification-message">{n.message}</div>
            {n.type !== 'loading' && (
              <button className="notification-close" onClick={() => remove(n.id)}>×</button>
            )}
          </div>
        ))}
      </div>
    </NotificationContext.Provider>
  );
};
